import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Chapter, FadeUp } from "./Reveal";
import { CAPABILITIES } from "../../data/content";

const Capabilities = () => (
    <section id="services" className="bg-white py-24 md:py-32" data-testid="services-section">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
            <Chapter
                index="01"
                label="Services"
                title={["One agency.", "Three levers."]}
                note="Everything a business needs to build, automate, and grow, grouped so it stays focused, not scattered."
            />

            <div className="grid md:grid-cols-3 gap-6 md:gap-8">
                {CAPABILITIES.map((cap, i) => (
                    <FadeUp key={cap.id} delay={i * 0.12}>
                        <motion.div
                            whileHover={{ y: -6 }}
                            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                            className="group h-full rounded-lg border border-slate-200 bg-white p-8 md:p-10 hover:border-accent/50 hover:shadow-[0_30px_60px_-30px_rgba(46,109,246,0.25)] transition-shadow duration-300"
                            data-testid={`capability-card-${cap.name.toLowerCase()}`}
                        >
                            <div className="flex items-start justify-between mb-10">
                                <span className="font-display text-sm tracking-[0.3em] text-slate-400">{cap.id}</span>
                                <ArrowUpRight className="w-5 h-5 text-slate-300 group-hover:text-accent transition-colors duration-300" />
                            </div>
                            <h3 className="font-display font-bold tracking-tight text-3xl md:text-4xl text-navy">
                                {cap.name}
                            </h3>
                            <p className="mt-2 text-sm font-medium text-accent">{cap.tagline}</p>
                            <ul className="mt-8 space-y-4">
                                {cap.items.map((item, j) => (
                                    <li key={j} className="flex items-start gap-3 text-sm md:text-base text-slate-600 leading-relaxed">
                                        <span className="mt-2 w-1.5 h-1.5 rounded-full bg-accent shrink-0" />
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </motion.div>
                    </FadeUp>
                ))}
            </div>
        </div>
    </section>
);

export default Capabilities;
